import http from "./httpService";

const apiEndpoint = "/Image";

export function sendImage(data) {
  return http.post(`${apiEndpoint}/upload`, data);
}
